import React, { memo } from 'react'
import { ExpandableRow } from 'transfix-ui/components/ExpandableRow'
import { IMatch } from 'apps/booking/types/carrierMatches'
import { CarrierSummary } from './CarrierSummary'
import { RowMetadata } from './RowMetadata'

export interface IMatchRow {
  match: IMatch
}

export const MatchRow = memo<IMatchRow>(({ match }) => (
  <div className='ph4'>
    <ExpandableRow
      id={match.carrierId}
      row={
        <div aria-label='Carrier Summary' className='flex pa2' tabIndex={0} role='button'>
          <div className='flex-grow-1 pr4'>
            <CarrierSummary match={match} />
          </div>
          <div className='flex-grow-2 pl2 mb0'>
            <RowMetadata match={match} />
          </div>
        </div>
      }
      rowClass='pl2 carrier-list-match mh0'
      details={
        <>
          <div className='b'>Coming soon: this carrier’s lane history!</div>
          <div>
            You’ll be able to see relevant lane history for this carrier – their rates and
            shipments.
          </div>
        </>
      }
    />
  </div>
))
